import { FormControlLabel, Stack, Switch, Tooltip, Typography } from "@mui/material";
import { useModalOfferContext } from "../context";

interface IOfferCreateInput {
  className?: string;
}
export const OfferCreateInput = ({ className }: IOfferCreateInput) => {
  const { createOffer, setCreateOffer, disabled, mode, offer, setOffer } = useModalOfferContext();
  const isAlreadyShared = mode === "editApply" && !!offer?.offerId;

  const actionSwitch = (
    <Switch
      id="offer-create"
      checked={createOffer}
      size="small"
      onClick={() => {
        const next = !createOffer;
        setCreateOffer(next);
        if (!next) {
          setOffer((offer) => ({ ...offer, url: "" }));
        }
      }}
      disabled={disabled || isAlreadyShared}
      color="primary"
    />
  );

  return (
    <Stack direction="row" alignItems="flex-start" justifyContent={"flex-start"} spacing={3} className={className}>
      <FormControlLabel
        control={
          isAlreadyShared && !disabled ? (
            <Tooltip title="Une offre associée a déjà été créée">
              <span>{actionSwitch}</span>
            </Tooltip>
          ) : (
            actionSwitch
          )
        }
        label={
          <Typography variant="body1" color={disabled ? "text.disabled" : "text.primary"}>
            Souhaitez-vous créer une offre associée à cette candidature et la partager aux autres utilisateurs ?
          </Typography>
        }
        labelPlacement="start"
        sx={{ alignItems: "flex-start" }}
      />
    </Stack>
  );
};
